// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_SPWLTuEU","container":"container_JyXLlnDz","noAvatar":"noAvatar_oP8ZhEcQ","avatar_isOnline":"avatar_isOnline_RLCIvVNp"};